import { NetworkIcons, ProductLogos } from "../../../assets";
class NotificationTypeUtils {
    static isNotificationTypeExpired(notificationType) {
        return notificationType.expiredAt ? (new Date(notificationType.expiredAt)) < (new Date()) : false;
    }
    static getRelatedProductImage(notificationType) {
        switch (notificationType.relatedProduct) {
            case 'app_discovery':
                return ProductLogos.AppDiscovery;
            case 'max':
            case 'ad_review':
                return ProductLogos.Max;
            case 'system':
                return NetworkIcons.AppLovin.Icon;
            default:
                return NetworkIcons.AppLovin.Icon;
        }
    }
    static getRelatedProductName(notificationType) {
        switch (notificationType.relatedProduct) {
            case 'app_discovery':
                return 'AppDiscovery';
            case 'max':
                return 'MAX';
            case 'ad_review':
                return 'Ad Review';
            case 'system':
                return 'AppLovin';
            default:
                return 'AppLovin';
        }
    }
}
export default NotificationTypeUtils;
//# sourceMappingURL=NotificationTypeUtils.js.map